export const joinWords = (values: string[], delimiter = ' ') =>
    values.join(delimiter);

export const takeFirstOption = (value: string, delimiter = '|') => {
    return value.split(delimiter)[0] || '';
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--12!./src/app/modules/shared/filters/genericStringFormatters.ts